export const APP_VERSION = '1.3.0';
export const BUILD_VERSION = '2026.08.21.28';
